<template>
  <el-row class="detail-row">
    <el-col v-for="(x, i) in infoList" :key="i" :span="x[2] || 12"><span>{{ x[0] }}</span><span>{{ x[1] || ''
    }}</span></el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    infoList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  components: {},
  data() {
    return {
    };
  },
  created() { },
  methods: {}
}
</script>
<style lang='scss' scoped>
.detail-row {
  line-height: 45px;
  font-size: 14px;
}
</style>